import { Marker } from 'react-map-gl'

import logo6Bios from '@/assets/images/svgs/logo-6bios-mapa.svg'

export interface MapMarkerProps {
  lat: string
  lng: string
  text?: string
  onClick?: () => void
}

export function MapMarker({ lat, lng, text, onClick }: MapMarkerProps) {
  return (
    <Marker
      onClick={onClick}
      latitude={Number(lat)}
      longitude={Number(lng)}
      className="hover:z-50"
    >
      <div className="group flex items-center">
        <img
          className="z-10 size-8 rounded-full border"
          alt="logo 6bios"
          src={logo6Bios}
        />
        {text && (
          <h1 className="ml-[-8px] hidden rounded-e-lg bg-white px-3 py-1 text-center font-bold group-hover:block">
            {text}
          </h1>
        )}
      </div>
    </Marker>
  )
}
